import { reducerWithInitialState } from 'typescript-fsa-reducers';

import { initialState } from './state';
import {
    fetchCustomerAction,
    fetchingMyfilter,
    setPreferredCountry,
    updatingMyfilter,
} from './actions';

import plusReducer from './plus/reducer';

const reducer = reducerWithInitialState(initialState)
    .case(setPreferredCountry, (state, preferredCountry) => ({
        ...state,
        preferredCountry,
    }))
    .case(fetchingMyfilter.started, state => ({
        ...state,
        myFilterLoading: true,
    }))
    .case(fetchingMyfilter.done, (state, { result }) => ({
        ...state,
        myFilterLoading: false,
        myFilter: result,
    }))
    .case(fetchingMyfilter.failed, (state, { error }) => ({
        ...state,
        myFilterLoading: false,
        errors: [...state.errors, error],
    }))
    .case(updatingMyfilter.started, state => ({
        ...state,
        myFilterLoading: true,
    }))
    .case(updatingMyfilter.done, (state, { result }) => ({
        ...state,
        myFilterLoading: false,
        myFilter: result,
    }))
    .case(updatingMyfilter.failed, (state, { error }) => ({
        ...state,
        myFilterLoading: false,
        errors: [...state.errors, error],
    }))
    .caseWithAction(fetchCustomerAction.started, (state, action) => ({
        ...state,
        isFetching: true,
        plus: plusReducer(state.plus, action),
    }))
    .caseWithAction(fetchCustomerAction.done, (state, action) => ({
        ...state,
        email: action.payload.result?.email,
        isFetching: false,
        isInitialized: true,
        plus: plusReducer(state.plus, action),
    }))
    .caseWithAction(fetchCustomerAction.failed, (state, action) => ({
        ...state,
        isFetching: false,
        plus: plusReducer(state.plus, action),
    }));

export default reducer;
